import type { ReactNode } from 'react';
import { makeStyles, mergeClasses, tokens } from '@fluentui/react-components';

const INLINE_REFERENCE_PATTERN = /\[\[([^[\]]+)\]\]/g;

const useStyles = makeStyles({
  root: {
    overflowWrap: 'anywhere',
  },
  reference: {
    display: 'inline',
    paddingInline: tokens.spacingHorizontalXS,
    borderRadius: tokens.borderRadiusMedium,
    backgroundColor: tokens.colorBrandBackground2,
    color: tokens.colorBrandForeground2,
    fontWeight: tokens.fontWeightSemibold,
    lineHeight: 'inherit',
    boxDecorationBreak: 'clone',
    WebkitBoxDecorationBreak: 'clone',
  },
});

type TProps = {
  text: string;
  className?: string;
};

const FindingText = ({ text, className }: TProps) => {
  const classes = useStyles();
  const segments: ReactNode[] = [];

  let lastIndex = 0;

  for (const match of text.matchAll(INLINE_REFERENCE_PATTERN)) {
    const [rawMatch, label] = match;
    const matchIndex = match.index ?? 0;

    if (matchIndex > lastIndex) {
      segments.push(text.slice(lastIndex, matchIndex));
    }

    segments.push(
      <span key={`${label}-${matchIndex}`} className={classes.reference}>
        {label}
      </span>
    );

    lastIndex = matchIndex + rawMatch.length;
  }

  if (lastIndex < text.length) {
    segments.push(text.slice(lastIndex));
  }

  return <span className={mergeClasses(classes.root, className)}>{segments.length > 0 ? segments : text}</span>;
};

export default FindingText;
